import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getVacancies } from '@/lib/data';
import type { Vacancy } from '@/lib/database.types';
import { CONTACT } from '@/lib/constants';

export function ContratacionesPreview() {
  const [vacancies, setVacancies] = useState<Vacancy[]>([]);

  useEffect(() => {
    void (async () => { setVacancies(await getVacancies(4)); })();
  }, []);

  return (
    <section id="contrataciones">
      <div className="wrap">
        <div className="contra-grid">
          <div className="contra-intro reveal-left">
            <span className="eyebrow">Recursos Humanos</span>
            <h2 className="st">ÚNETE A<br />NUESTRO<br />EQUIPO</h2>
            <p>
              En Empacadora Las Polvillas buscamos personas comprometidas que quieran crecer junto a
              nosotros. Ofrecemos un ambiente de trabajo profesional, prestaciones de ley y
              oportunidades de desarrollo.
            </p>
            <p>
              Si no encuentras una vacante que se ajuste a tu perfil, envíanos tu información y te
              contactamos cuando surja una oportunidad.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
              <a href={`mailto:${CONTACT.emailRH}`} className="btn">
                <i className="fa fa-envelope" style={{ marginRight: 8 }} /> ENVIAR CV
              </a>
              <a href={`https://wa.me/${CONTACT.whatsappRH}`} target="_blank" rel="noopener" className="btn">
                <i className="fab fa-whatsapp" style={{ marginRight: 8 }} /> {CONTACT.phoneRH}
              </a>
            </div>
          </div>

          <div className="reveal-right">
            <div className="vacantes-list">
              {vacancies.length === 0 ? (
                <div className="no-vacantes">
                  No hay vacantes activas en este momento. Envíanos tu CV y te avisamos cuando surja
                  una oportunidad.
                </div>
              ) : (
                vacancies.map((v) => (
                  <Link key={v.id} to="/vacantes" className="vacante-card" style={{ textDecoration: 'none' }}>
                    <div className="vc-area">{v.area}</div>
                    <div className="vc-titulo">{v.titulo}</div>
                    <span className="vc-tipo">{v.tipo}</span>
                    {v.descripcion && <p className="vc-desc">{v.descripcion}</p>}
                    <button type="button" className="vc-apply">
                      POSTULARME <i className="fa fa-arrow-right" />
                    </button>
                  </Link>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
